// extracted by mini-css-extract-plugin
export default {"textarea":"Textarea_textarea__CrLGD","dark":"Textarea_dark__s12El"};